export enum EmailSettingsContext {
    COMPANY = 'company',
    USER = 'user',
}
